import { Injectable } from '@angular/core';

import { WarpType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class WarpTypeService extends TmsWebBaseEditService<WarpType, WarpType> {
  constructor() {
    super('WarpType', $localize`Warp Type`);
  }
}
